import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as payrollExpenses from '../../../../payroll-expenses'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Associated payroll expense entry',
    isOptional: false,
    name: 'Payroll Expense',
    partialId: PartialId.Standard.create('pay_exp'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        payrollExpenses.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
